import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-white dark:bg-slate-950 border-t border-slate-200/60 dark:border-slate-900 py-6 px-4 md:px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Left side: branding & copy */}
        <div className="text-center md:text-left space-y-1">
          <span className="font-display font-bold text-slate-800 dark:text-slate-200">
            Econ<span className="text-brand-500">Dock</span>
          </span>
          <p className="text-xs text-slate-400 dark:text-slate-500">
            &copy; {currentYear} EconDock. All calculations are performed entirely in your browser.
          </p>
          <div className="flex flex-wrap justify-center md:justify-start gap-3 text-xs text-slate-400 dark:text-slate-500 pt-1">
            <Link to="/privacy" className="hover:text-brand-500 transition">Privacy Policy</Link>
            <span>&bull;</span>
            <Link to="/terms" className="hover:text-brand-500 transition">Terms of Service</Link>
            <span>&bull;</span>
            <Link to="/disclaimer" className="hover:text-brand-500 transition">Disclaimer</Link>
            <span>&bull;</span>
            <a 
              href="mailto:jtscientific2016@gmail.com?subject=Support%20Inquiry%20-%20EconDock&body=Hello%20Support%2C%0A%0A"
              className="hover:text-brand-500 transition font-semibold text-brand-600 dark:text-brand-400"
            >
              Email Us
            </a>
          </div>
        </div>

        {/* Right side: disclaimer & privacy */}
        <div className="flex flex-col items-center md:items-end text-xs text-slate-400 dark:text-slate-500">
          <p className="font-medium text-slate-500 dark:text-slate-400">
            🔒 Privacy First: No user data is sent to servers.
          </p>
          <p className="text-[10px] leading-relaxed mt-1 text-center md:text-right max-w-sm">
            Disclaimer: EconDock is an educational utility. Calculations are for reference and homework checking only. Not intended for commercial or professional advisory use.
          </p>
        </div>
      </div>
    </footer>
  );
}
